import { FilterSettingsModel, EditMode } from "../../common/models/CommonModels";
import { Reducer } from "redux";
import { SingleResourceLoadingState, AddEditResourceState, ResourceLoadingState, SelectResourceState } from "../../common/store/stateHelpers";



export enum ActionType {
    RequestFilterSettingsData = "FILTERSETTINGS/REQUEST_FILTERSETTINGS",
    ReceivedFilterSettingsData = "FILTERSETTINGS/RECEIVED_FILTERSETTINGS",
    AddOrEditFilterSetting = "FILTERSETTINGS/ADD_OR_EDIT_FILTERSETTINGS",
    EditFilterSetting = "FILTERSETTINGS/EDIT_FILTERSETTINGS",
    DeleteFilterSetting = "FILTERSETTINGS/DELETE_FILTERSETTINGS",
    AddEditFilterSettingStarted = "FILTERSETTINGS/ADD_EDIT_STARTED_FILTERSETTINGS",
    AddEditFilterSettingSuccess = "FILTERSETTINGS/ADD_EDIT_SUCCESS_FILTERSETTINGS",
    AddNewFormSubmitted = "FILTERSETTINGS/FORMS/ADD_NEW_SUBMITTED",
    AddNewFormCancelled = "FILTERSETTINGS/FORMS/ADD_NEW_CANCELLED",
    updateNewFilterSettingsDestinationCities = "FILTERSETTINGS/UPDATE_NEW_FILTERSETTINGS_FORM_DESTINATION_CITIES",
    updateNewFilterSettingsDepartureCities = "FILTERSETTINGS/UPDATE_NEW_FILTERSETTINGS_FORM_DEPARTURE_CITIES",
    FilterSettingSelected = "FILTERSETTINGS/FILTERSETTING_SELECTED",
    updateNewFilterSettingsReporters = "FILTERSETTINGS/UPDATE_NEW_FILTERSETTINGS_FORM_REPORTERS",
    DeleteFilterSettingStarted = "SETTINGS/DELETE_FILTERSETTING_STARTED"
}


export interface RequestFilterSettingsDataAction {
    type: ActionType.RequestFilterSettingsData,
}

export interface ReceivedFilterSettingsDataAction {
    type: ActionType.ReceivedFilterSettingsData;
    data: FilterSettingsModel[];
}

export interface UpdateNewFilterSettingsDestinationCitiesAction {
    type: ActionType.updateNewFilterSettingsDestinationCities;
    data: string[];
}

export interface UpdateNewFilterSettingsDepartureCitiesAction {
    type: ActionType.updateNewFilterSettingsDepartureCities
    data: string[];
}

export interface UpdateNewFilterSettingsReportersAction {
    type: ActionType.updateNewFilterSettingsReporters
    data: string[];
}

export interface AddOrEditFilterSettingAction {
    type: ActionType.AddOrEditFilterSetting;
    data?: FilterSettingsModel;
    afterAddOrEdit?: () => void;
}

export interface EditFilterSettingAction {
    type: ActionType.EditFilterSetting,
    data: FilterSettingsModel;
}

export interface DeleteFilterSettingAction {
    type: ActionType.DeleteFilterSetting;
    data: FilterSettingsModel;
}

export interface AddEditFilterSettingStartedAction {
    type: ActionType.AddEditFilterSettingStarted,
    data?: FilterSettingsModel
}

export interface AddEditFilterSettingSuccessAction {
    type: ActionType.AddEditFilterSettingSuccess
}

interface AddNewFormSubmittedAction {
    type: ActionType.AddNewFormSubmitted,
    data: FilterSettingsModel
}

interface AddNewFormCancelledAction {
    type: ActionType.AddNewFormCancelled
}

export interface FilterSettingSelectedAction {
    type: ActionType.FilterSettingSelected,
    data: FilterSettingsModel;
}

export interface DeleteFilterSettingAction {
    type: ActionType.DeleteFilterSetting,
    data: FilterSettingsModel;
}


export const actionsCreators = {
    RequestFilterSettingsData: () => <RequestFilterSettingsDataAction>{ type: ActionType.RequestFilterSettingsData },
    ReceivedFilterSettingsData: (data: FilterSettingsModel[]) => <ReceivedFilterSettingsDataAction>{ type: ActionType.ReceivedFilterSettingsData, data },
    AddOrEditFilterSetting: (data?: FilterSettingsModel, afterAddOrEdit?: () => void) => <AddOrEditFilterSettingAction>{ type: ActionType.AddOrEditFilterSetting, data, afterAddOrEdit },
    addOrEditFilterSettingStarted: (data?: FilterSettingsModel) => <AddEditFilterSettingStartedAction>{ type: ActionType.AddEditFilterSettingStarted, data },
    addOrEditFilterSettingSuccess: () => <AddEditFilterSettingSuccessAction>{ type: ActionType.AddEditFilterSettingSuccess },
    DeleteFilterSetting: (data: FilterSettingsModel) => <DeleteFilterSettingAction>{ type: ActionType.DeleteFilterSetting, data },
    addOrEditFormSubmitted: (values: FilterSettingsModel) => <AddNewFormSubmittedAction>{ type: ActionType.AddNewFormSubmitted, data: values },
    addOrEditFormCancelled: () => <AddNewFormCancelledAction>{ type: ActionType.AddNewFormCancelled },
    updateNewFilterSettingsDestinationCities: (data: string[]) => <UpdateNewFilterSettingsDestinationCitiesAction>{ type: ActionType.updateNewFilterSettingsDestinationCities, data },
    updateNewFilterSettingsDepartureCities: (data: string[]) => <UpdateNewFilterSettingsDepartureCitiesAction>{ type: ActionType.updateNewFilterSettingsDepartureCities, data },
    updateNewFilterSettingsReporters: (data: string[]) => <UpdateNewFilterSettingsReportersAction>{ type: ActionType.updateNewFilterSettingsReporters, data },
    FilterSettingSelected: (data: FilterSettingsModel) => <FilterSettingSelectedAction>{ type: ActionType.FilterSettingSelected, data }
}

export type FilterSettingsState = ResourceLoadingState<FilterSettingsModel> &
    AddEditResourceState<FilterSettingsModel> &
    SelectResourceState<FilterSettingsModel> &
    EditMode;


const initialState: FilterSettingsState = {
        isLoading: false,
        data: [],
        isEditing: false,
        editedItem: undefined,
        selected: null
}


type FilterSettingsAction = RequestFilterSettingsDataAction | 
    ReceivedFilterSettingsDataAction | 
    AddEditFilterSettingStartedAction | 
    AddEditFilterSettingSuccessAction |
    FilterSettingSelectedAction; // | AddFilterSettingAction | EditFilterSettingAction | DeleteFilterSettingAction;

export const reducer: Reducer<FilterSettingsState> = (state: FilterSettingsState, action: FilterSettingsAction) => {
    switch (action.type) {
        case ActionType.RequestFilterSettingsData:
            return {
                ...state,
                isLoading: true
            };
        case ActionType.ReceivedFilterSettingsData:
            return {
                ...state,
                isLoading: false,
                data: action.data
            }
        case ActionType.AddEditFilterSettingStarted:
            return {
                ...state,
                isEditing: true,
                editedItem: action.data,
                editMode: action.data ? "edit" : "add"
            }
        case ActionType.AddEditFilterSettingSuccess:
            return {
                ...state,
                isEditing: false,
                editedItem: undefined,
                editMode: undefined
            }
        case ActionType.FilterSettingSelected:
            return {
                ...state,
                selected: action.data,
            }
        default:
            const exCheck: never = action;
    }

    return state || initialState;
}



// WEBPACK FOOTER //
// ./src/account/store/FilterSettingsStore.ts